import { BaseError } from "./AuthError";

export class InfraError extends BaseError {
  constructor(
    message: string,
    code: string = "INFRA_ERROR",
    statusCode: number = 500
  ) {
    super(message, code, statusCode);
  }
}

export class NetworkError extends InfraError {
  constructor(message: string = "Erro de conexão") {
    super(message, "NETWORK_ERROR", 0);
  }
}

export class ApiError extends InfraError {
  constructor(
    message: string = "Erro na API",
    statusCode?: number,
    public readonly endpoint?: string,
    public readonly method?: string
  ) {
    super(message, "API_ERROR", statusCode);
  }
}

export class DatabaseError extends InfraError {
  constructor(message: string = "Erro no banco de dados") {
    super(message, "DATABASE_ERROR", 500);
  }
}

export class ConfigurationError extends InfraError {
  constructor(message: string) {
    super(message, "CONFIGURATION_ERROR", 500);
  }
}
